/* const initAuth = () => {
  return window.gapi.auth2.init({
    client_id: "UA-250439478-1", //paste your client ID here
    scope: "https://www.googleapis.com/auth/analytics.readonly",
  });
}; */

export const getMultiLngInitValue = (table, fieldName, languages, content = undefined) => {
  if (!languages) return [];
  const lngArray = languages.split(",");
  const contentRes = [];

  for (let index = 0; index < lngArray.length; index++) {
    const lng = lngArray[index];
    if (content) {
      const contentLng = content.find((el) => el.lingua === lng);
      if (contentLng) contentRes.push(contentLng);
      else {
        contentRes.push({
          id: null,
          tabella: table,
          nomecampo: fieldName,
          idrecordcollegato: null,
          lingua: lng,
          testo: null,
        });
      }
    } else {
      contentRes.push({
        id: null,
        tabella: table,
        nomecampo: fieldName,
        idrecordcollegato: null,
        lingua: lng,
        testo: null,
      });
    }
  }
  return contentRes;
};

export const validateMultiLanguageEditor = (value, languages) => {
  let isEmpty = true;

  if (value !== undefined) {
    const lngArray = languages.split(",");
    isEmpty =
      value.filter((el) => lngArray.includes(el.lingua)).find((el) => el.testo === "") ||
      value.length === 0 ||
      lngArray.length > value.length;
  }
  return isEmpty === true ? "Campo richiesto per tutte le lingue" : undefined;
};

export const initValue = (contents, dropDown = undefined, inputComp = undefined) => {
  let res = {};
  if (dropDown) {
    res = { [dropDown.name]: contents[dropDown.name] };
  }
  if (inputComp) {
    res = { ...res, [inputComp.name]: contents[inputComp.name] };
  }
  if (!!contents && Object.keys(contents).length !== 0) {
    const nome = contents.traduzione.filter((traduzione) => traduzione.nomecampo === "nome");
    const descrizione = contents.traduzione.filter((traduzione) => traduzione.nomecampo === "descrizione");
    const valore = contents.traduzione.filter((traduzione) => traduzione.nomecampo === "valore");
    res = { ...res, nome, descrizione, valore };
  }
  return res;
};
